import { v4 as uuidv4 } from 'uuid'

export const useUserStore = defineStore('user', {
  state: () => ({
    email: '',
    referrer: '',
    uuid: '',
    shippingAddress: {},
    billingAddress: {},
    supportArticleRatings: {},
    gclid: '',
    dismissedWelcomeDiscountToast: false,
    showEmailSignUpModal: { visible: false, canClose: true, standard: false },
    welcomeDiscountCode: '',
    givenPreferences: false,
    emailSignUpModalState: 'sign-up',
    dismissedSungodPlusModal: false,
    ambassadorId: '',
    // Campaign id → entered option id; one entry per campaign, enforced client-side only (ADR 0005)
    multiCompetitionEntry: {} as Record<string, string>,
  }),

  getters: {
    isSunGodPlusMember(state): boolean {
      return !!state.email
    },
  },

  actions: {
    setUserEmail(value) {
      this.email = value
    },
    setReferrer(value) {
      this.referrer = value
    },
    setUUID() {
      if (this.uuid) return
      this.uuid = uuidv4()
    },
    rateSupportArticle(articleId, rating) {
      this.supportArticleRatings[articleId] = rating
    },
    setGoogleClickID(gclid) {
      this.gclid = gclid || this.gclid || ''
    },
    setShowEmailSignUpModal(showEmailSignUpModal: {
      visible: boolean
      canClose?: boolean
      standard?: boolean
    }) {
      this.showEmailSignUpModal = {
        ...{ canClose: true, standard: false },
        ...showEmailSignUpModal,
      }

      if (showEmailSignUpModal.visible) {
        const { $track } = useNuxtApp()
        $track.emailSignup.seen()
      }
    },
    setEmailSignUpModalState(emailSignUpModalState) {
      this.emailSignUpModalState = emailSignUpModalState
    },
    setWelcomeDiscountCode(welcomeDiscountCode) {
      this.welcomeDiscountCode = welcomeDiscountCode
    },
    setGivenPreferences(givenPreferences) {
      this.givenPreferences = givenPreferences
    },
    setDismissedWelcomeDiscountToast(dismissedWelcomeDiscountToast) {
      this.dismissedWelcomeDiscountToast = dismissedWelcomeDiscountToast
    },
    setDismissedSungodPlusModal(dismissedSungodPlusModal) {
      this.dismissedSungodPlusModal = dismissedSungodPlusModal
    },
    setMultiCompetitionEntry(campaignId: string, optionId: string) {
      this.multiCompetitionEntry = { ...this.multiCompetitionEntry, [campaignId]: optionId }
    },
    async setAmbassadorId(ambassadorId: string) {
      this.ambassadorId = ambassadorId
      const { $track } = useNuxtApp()
      await $track.global.ambassadorLinkOpened({ ambassadorId })
    },
  },

  persist: [
    {
      storage: piniaPluginPersistedstate.localStorage(),
      pick: [
        'email',
        'referrer',
        'uuid',
        'supportArticleRatings',
        'gclid',
        'welcomeDiscountCode',
        'givenPreferences',
        'dismissedWelcomeDiscountToast',
        'dismissedSungodPlusModal',
        'emailSignUpModalState',
        'multiCompetitionEntry',
      ],
    },
    {
      storage: piniaPluginPersistedstate.cookies({
        maxAge: 60 * 60 * 24 * 30, // 30 days
        sameSite: 'strict',
        secure: true,
        path: '/',
      }),
      pick: ['ambassadorId'],
    },
  ],
})
